import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials ensures the browser sends the httpOnly `mbl_admin_session` cookie
// on cross-origin admin requests. No tokens are read from localStorage anymore.
const client = axios.create({ baseURL: API, withCredentials: true });

export default client;
